import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectBorderModeDS } from "@EUForms/selectors";

const  BorderTransportModeDetail=({saveData,updateData,renderForm})=>{
  const dataSource =useSelector(selectBorderModeDS);
   const dispatch=useDispatch()
    const onBlur=useCallback(({target: {value,name}})=>saveData({"borderTransportMode":{[name]:value || " "}}),[saveData])
    const onChange=useCallback(({target: {value,name}})=>dispatch(updateData({key:"borderTransportMode",data:{[name]:value}})),[updateData])
    const onSelect=useCallback((e, {value, name})=>{
      onChange({target: {value:value?.trim(), name}});
      onBlur({target: {value, name}})
    },[onChange,onBlur])
  return(
    renderForm && renderForm({onBlur,onSelect,onChange,dataSource})
  )
}


export default BorderTransportModeDetail